import { type Images } from '@neos/app'
import collapsePath from '../../modules/dependencies/UserPermissions.3.1.9/images/Collapse.svg'
import downPath from '../../modules/dependencies/UserPermissions.3.1.9/images/Down.svg'
import errorClusterPath from '../../modules/dependencies/UserPermissions.3.1.9/images/ErrorCluster.svg'
import expandPath from '../../modules/dependencies/UserPermissions.3.1.9/images/Expand.svg'
import externalClusterPath from '../../modules/dependencies/UserPermissions.3.1.9/images/ExternalCluster.svg'
import roleUsersPath from '../../modules/dependencies/UserPermissions.3.1.9/images/RoleUsers.svg'
import syncBlackPath from '../../modules/dependencies/UserPermissions.3.1.9/images/SyncBlack.svg'
import upPath from '../../modules/dependencies/UserPermissions.3.1.9/images/Up.svg'
import userAccountPath from '../../modules/dependencies/UserPermissions.3.1.9/images/UserAccount.svg'
import userClientPath from '../../modules/dependencies/UserPermissions.3.1.9/images/UserClient.svg'
import userFunctionPath from '../../modules/dependencies/UserPermissions.3.1.9/images/UserFunction.svg'
import userPermissionsSendEmailPath from '../../modules/dependencies/UserPermissions.3.1.9/images/UserPermissionsSendEmail.svg'
import userPermissionsSendSMSPath from '../../modules/dependencies/UserPermissions.3.1.9/images/UserPermissionsSendSMS.svg'
import userPublisherPath from '../../modules/dependencies/UserPermissions.3.1.9/images/UserPublisher.svg'

const images: Images = {
  collapse: { path: collapsePath, colored: false },
  down: { path: downPath, colored: false },
  editUser: 'edit',
  error: 'error',
  errorCluster: { path: errorClusterPath, colored: true },
  expand: { path: expandPath, colored: false },
  externalCluster: { path: externalClusterPath, colored: true },
  info: 'info',
  neosPrint: 'print',
  roleUsers: { path: roleUsersPath, colored: false },
  syncBlack: { path: syncBlackPath, colored: false },
  up: { path: upPath, colored: false },
  userAccount: { path: userAccountPath, colored: false },
  userClient: { path: userClientPath, colored: false },
  userFunction: { path: userFunctionPath, colored: false },
  userPermissionsSendEmail: { path: userPermissionsSendEmailPath, colored: false },
  userPermissionsSendSMS: { path: userPermissionsSendSMSPath, colored: false },
  userPublisher: { path: userPublisherPath, colored: false },
  warning: 'warning',
}

export default images